module.exports = __webpack_public_path__ + "img/8.3b1aa9cb.jpg";